export const availableBrands = [
  {
    id: '44bc5045-47a6-4098-b825-7e5dcf5dbb6c',
    brandId: '44bc5045-47a6-4098-b825-7e5dcf5dbb6c',
    name: 'Kassa',
    slug: 'kassa',
    backgroundImageUrl:
      'https://d36pj450k6628s.cloudfront.net/{format}/s3-kassa-bnnvara/442f2b23-280a-4c7f-b9c9-bb425d19f119.jpg',
    backgroundImageMobileUrl:
      'https://d36pj450k6628s.cloudfront.net/{format}/s3-kassa-bnnvara/442f2b23-280a-4c7f-b9c9-bb425d19f119.jpg',
  },
  {
    id: '10ad3c9f-6706-4cfa-8eaf-f2da8410b461',
    brandId: '10ad3c9f-6706-4cfa-8eaf-f2da8410b461',
    name: '3 op Reis',
    slug: '3opreis',
    backgroundImageUrl:
      'https://dn82kyshjefw9.cloudfront.net/{format}/s3-3opreis-bnnvara/7c007f88-27a9-4e49-b02a-7859d8b0a892.jpg',
    backgroundImageMobileUrl:
      'https://dn82kyshjefw9.cloudfront.net/{format}/s3-3opreis-bnnvara/7c007f88-27a9-4e49-b02a-7859d8b0a892.jpg',
  },
  {
    id: '4520ac0d-7ad3-452a-b3be-0637b75b2381',
    brandId: '4520ac0d-7ad3-452a-b3be-0637b75b2381',
    name: 'Zembla',
    slug: 'zembla',
    backgroundImageUrl:
      'https://d14nv6jgvp73rr.cloudfront.net/{format}/s3-zembla-bnnvara/9ec62842-1f3f-4417-b336-440a3c02c935.png',
    backgroundImageMobileUrl:
      'https://d14nv6jgvp73rr.cloudfront.net/{format}/s3-zembla-bnnvara/956f5163-edcc-4748-bc0a-055caaa4da9e.png',
  },
  {
    id: 'f60e58b2-3af3-4bfc-a872-aa27135a953d',
    brandId: 'f60e58b2-3af3-4bfc-a872-aa27135a953d',
    name: 'First Dates',
    slug: 'firstdates',
    backgroundImageUrl:
      'https://pips-bnnvara.cdn.prepr.io/{format}/s3-pips-bnnvara/4e69d79f-86ed-40a9-8f35-dd12a1cec6ba.png',
    backgroundImageMobileUrl:
      'https://pips-bnnvara.cdn.prepr.io/{format}/s3-pips-bnnvara/e14aa53a-9f26-4187-854e-323504f3b3a1.png',
  },
];
